<div class="payment-block theme-cartPagePaymentBlock__bg">
  <div class="payment-block__money-container">
    <!--Sum-->
    <div class="payment-block__money-block">
      <p class="payment-block__info-title theme-cartPagePaymentBlock__infoKey">
        {{ lg.cartPage.sum }}
      </p>
      <p class="payment-block__info-money theme-cartPagePaymentBlock__infoValue">
        {{ group.fullPrice }} {{ currencySign }}
      </p>
    </div>
    <div class="payment-block__divider-line theme-cartPagePaymentBlock__infoDividerLine"></div>

    <!--Discount-->
    <div class="payment-block__money-block">
      <p class="payment-block__info-title theme-cartPagePaymentBlock__infoKey">
        {{ lg.cartPage.discount }}
      </p>
      <p class="payment-block__info-money theme-cartPagePaymentBlock__infoValue">
        {{ group.fullPrice - group.priceWithDiscount }} {{ currencySign }}
      </p>
    </div>
    <div class="payment-block__divider-line theme-cartPagePaymentBlock__infoDividerLine"></div>
  </div>

  <div class="payment-block__total-price-container">
    <bmcore-payment-bottom-block
      [currencySign]="currencySign"
      [priceWithDiscount]="group.priceWithDiscount"
      [cashbackAmount]="group.cashbackAmount"
      [parentComponent]="'Checkout page'"
    >
    </bmcore-payment-bottom-block>
  </div>

  <bmcore-button
    themeBtnClass="theme-btn__cartPagePaymentBlock-btnConfirm"
    themeIconClass="theme-icon__cartPagePaymentBlock-btnConfirmIcon"
    title="{{ lg.button.confirm }}"
    icon="btv-icon-cart"
    (clickHandler)="switchConfirmationOrderPopup(true)"
  >
  </bmcore-button>
</div>

@if (isConfirmationOrderPopup) {
  <bmcore-confirmation-order-popup
    [group]="group"
    (switchConfirmationOrderPopup)="switchConfirmationOrderPopup($event)"
    [paymentSource]="paymentSource"
    [colorSettingsMode]="colorSettingsMode"
    [widgetId]="widgetId"
  >
  </bmcore-confirmation-order-popup>
}
